<template>
  <div
    class="document-list"
    :class="documentClasses"
    :style="`--btns: ${countButtons * 35}px`">
    <sIcon
      v-if="!history"
      :size="small ? '18' : '24'"
      type="draft"/>
    <div
      class="document-list_info"
      :class=" {'pa-0' : small}">
      <div
        class="document-list_info-title"
        :class="{'text-error': value.error}"
        data-qa="file-title"
        :title="value.error ? value.error : ''">
        {{ value.title }}
      </div>
      <sProgress
        v-if="value.loading"
        class="mt-2 mb-1"
        :value="value.loadingPercentage"/>
      <div
        v-else-if="value.getFileSize || value.size || (value.versions && value.versions.length)"
        class="document-list_info-row-2">
        <div
          v-if="value.getFileSize || value.size"
          class="h8-text my-auto"
          data-qa="file-size"
          v-text="getSize(value.getFileSize || value.size)"/>
        <div
          v-if="value.versions && value.versions.length"
          class="ml-5 text-uppercase font-size-11 flex pointer"
          @click="showHistoryMutable = !showHistoryMutable">
          {{ $t('Common.previousVersions') }}
          <sIcon
            class="ml-1 my-auto"
            :rotate="showHistoryMutable ? 180 : 0"
            size="11"
            type="arrow"/>
        </div>
      </div>
    </div>
    <div
      v-if="value.dateModified"
      class="document-list_dateModified"
      data-qa="dateModified">
      {{ value.dateModified ? `${$d(new Date(value.dateModified), "shortDate")} ${$d(new Date(value.dateModified), "time")}` : '' }}
    </div>
    <div
      v-show="countButtons"
      class="document-list_btns">
      <slot name="buttons"/>
    </div>
  </div>
</template>
<script>

export default {
  name: 'DocumentListItem',
  methods: {
    getSize(length) {
      // mb
      if (length > 1024 * 1024) {
        return `${Math.round(length / (1024 * 1024))} ${this.$t('Common.Mb')}`
      } else if (length > 1024) {
        return `${Math.round(length / 1024)} ${this.$t('Common.Kb')}`
      }
      return `${length} ${this.$t('Common.bytes')}`
    },
  },
  computed: {
    documentClasses() {
      return {
        'main__light_green': this.in_creating,
        'small': this.small,
        'not-active': !this.value.isActive || this.value.deleted,
        'full': this.value.dateModified,
        'show-history': this.showHistoryMutable,
        'is-history': this.history
      }
    },
    countButtons() {
      if (!this.$slots.buttons) {
        return 0
      }
      return this.$slots.buttons.filter(i => i.tag)?.length || 0
    },
    showHistoryMutable: {
      get() {
        return this.showHistory
      },
      set(newValue) {
        this.$emit('update:showHistory', newValue)
      }
    }
  },
  props: {
    /**
     * Данные файла
     */
    value: {
      type: Object
    },
    /**
     * Свойство для синхронизации статуса отображения истории
     */
    showHistory: {
      type: Boolean,
    },
    small: {
      type: Boolean,
    },
    /**
     * Файл из истории
     */
    history: {
      type: Boolean,
    },
    in_creating: {
      type: Boolean,
    },
  },
}
</script>
<style lang="scss" scoped>
.document-list {
  $item: &;
  display: grid;
  grid-template-columns: 35px 1fr var(--btns);
  border-radius: 4px;
  align-items: center;
  text-align: left;
  padding-left: 8px;
  margin-bottom: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
  background-color: var(--v-secondary__green_chosen-base);
  border-color: var(--v-secondary__green_chosen-base);
  &.not-active {
    color: var(--text-text, #686868);
    #{$item}_info-title {
      font-weight: 400;
    }
  }
  &.full {
    grid-template-columns: 35px 1fr auto auto;
  }
  &.show-history {
    margin-bottom: 0px;
  }
  &.is-history {
    position: relative;
    margin-bottom: 0;
    border-radius: 0;
    padding-left: 45px;
    grid-template-columns: 1fr 180px;
    &:before {
      content: '';
      background: var(--v-main__green-base);
      height: 1px;
      position: absolute;
      left: 10px;
      right: 10px;
      top: 0;
    }
    &.full {
      grid-template-columns: 1fr 130px 180px;
    }
    &:last-child {
      margin-bottom: 8px;
    }
  }
  &.small {
    min-height: 30px;
  }
  &_info {
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    &-title {
      font-weight: 500;
    }
    &-row-2 {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }
  }
  &_btns {
    gap: 5px;
    width: 100%;
    display: flex;
    margin: auto 0 auto auto;
    justify-content: flex-end;
  }
}
</style>
